<template>
  <Toggle
    v-model="inner"
    :on-label="onLabel"
    :off-label="offLabel"
    class="toggle-button"
  />
</template>

<script>
import Toggle from '@vueform/toggle'
import '@vueform/toggle/themes/default.css'

export default {
  name: 'ToggleButton',
  components: { Toggle },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Boolean,
      default: undefined
    },
    sync: {
      type: Boolean,
      default: false
    },
    labels: {
      type: [Boolean, Object],
      default: false
    }
  },
  emits: ['input', 'update:modelValue', 'change'],
  computed: {
    inner: {
      get () {
        return this.modelValue !== undefined ? this.modelValue : this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('update:modelValue', val)
        this.$emit('change', val)
      }
    },
    onLabel () {
      if (this.labels === true) return 'On'
      if (this.labels && typeof this.labels === 'object') {
        return this.labels.checked || this.labels.on || 'On'
      }
      return null
    },
    offLabel () {
      if (this.labels === true) return 'Off'
      if (this.labels && typeof this.labels === 'object') {
        return this.labels.unchecked || this.labels.off || 'Off'
      }
      return null
    }
  }
}
</script>
